"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class MoobiQueries {
    constructor(hostname) {
        this.renderMainCart = () => __awaiter(this, void 0, void 0, function* () {
            const mainCart = document.getElementById('main-cart-div');
            if (!mainCart)
                return;
            const sectionId = mainCart === null || mainCart === void 0 ? void 0 : mainCart.dataset.sectionid;
            const sectionRes = yield moobiQueries.renderSection([sectionId]);
            const sectionString = sectionRes[sectionId];
            const sectionInnerHTML = this.getSectionInnerHTML(sectionString, `#main-cart-div`);
            mainCart.innerHTML = sectionInnerHTML;
            // mainCart.scrollIntoView()
        });
        this.renderMainCartMoobiPointsRedeem = () => __awaiter(this, void 0, void 0, function* () {
            // const divId = 'moobiPoints_main_section'
            const divId = 'redeemOptionsWrapper';
            const mainDiv = document.getElementById(divId);
            if (!mainDiv)
                return;
            const sectionId = mainDiv === null || mainDiv === void 0 ? void 0 : mainDiv.dataset.sectionid;
            const sectionRes = yield moobiQueries.renderSection([sectionId]);
            const sectionString = sectionRes[sectionId];
            const sectionInnerHTML = this.getSectionInnerHTML(sectionString, `#${divId}`);
            mainDiv.innerHTML = sectionInnerHTML;
        });
        this.articleVectorSearch = (handle) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestOptions = {
                    method: 'GET',
                    redirect: 'follow'
                };
                const response = yield fetch(`${this.hostName}/api/carWashNavi/vArticles?articleQ=${handle}`, requestOptions);
                const result = yield response.text();
                const data = yield JSON.parse(result);
                return data;
            }
            catch (err) {
                console.log(err);
            }
        });
        this.productVectorSearch = (handle) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestOptions = {
                    method: 'GET',
                    redirect: 'follow'
                };
                const response = yield fetch(`${this.hostName}/api/carWashNavi/vProducts?productQ=${handle}`, requestOptions);
                const result = yield response.text();
                const data = yield JSON.parse(result);
                return data;
            }
            catch (err) {
                console.log(err);
            }
        });
        this.smtCollectionVectorSearch = (handle) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestOptions = {
                    method: 'GET',
                    redirect: 'follow'
                };
                const response = yield fetch(`${this.hostName}/api/carWashNavi/vSmtCollections?collectionQ=${handle}`, requestOptions);
                const result = yield response.text();
                const data = yield JSON.parse(result);
                return data;
            }
            catch (err) {
                console.log(err);
            }
        });
        this.getEmbeddings = (handle) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestOptions = {
                    method: 'GET',
                    redirect: 'follow'
                };
                const response = yield fetch(`${this.hostName}/api/v00/dynamicHP/embedquery?searchQuery=${handle}`, requestOptions);
                const result = yield response.text();
                const data = yield JSON.parse(result);
                return data;
            }
            catch (err) {
                console.log(err);
            }
        });
        this.hostName = hostname;
    }
    getPdtDetails(handle) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const requestOptions = {
                    method: 'GET',
                    redirect: 'manual'
                };
                const res = yield fetch(`${this.hostName}/api/v00/dynamicHP/getOnepdt?handle=${handle}`, requestOptions);
                const text = yield res.text();
                const data = yield JSON.parse(text);
                return data;
            }
            catch (err) {
                return null;
                console.log(err);
            }
        });
    }
    getPdtCpr(handle) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // return resdata or false
                let requestOptions = {
                    method: 'GET',
                    redirect: 'manual'
                };
                const res = yield fetch(`${this.hostName}/api/v00/comparisons/param?handle=${handle}`, requestOptions);
                const text = yield res.text();
                const data = yield JSON.parse(text);
                if (data.results) {
                    return data;
                }
                else {
                    return false;
                }
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    getMongoSolutionById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // return resdata or false
                let requestOptions = {
                    method: 'GET',
                    redirect: 'manual'
                };
                const res = yield fetch(`${this.hostName}/api/v00/solutions?_id=${id}`, requestOptions);
                const text = yield res.text();
                const data = yield JSON.parse(text);
                if (data.results) {
                    return data;
                }
                else {
                    return false;
                }
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    getPdtLists(tags) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                const raw = JSON.stringify({ tags: tags });
                const requestOptions = {
                    mode: 'cors',
                    method: 'POST',
                    headers: myHeaders,
                    body: raw,
                    redirect: 'manual'
                };
                const res = yield fetch(`${this.hostName}/api/v00/dynamicHP/getPdtListsByTags`, requestOptions);
                const text = yield res.text();
                const data = yield JSON.parse(text);
                return data.data;
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    getProductListbyCollectionId(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const requestOptions = {
                    method: 'GET',
                    redirect: 'manual'
                };
                const response = yield fetch(`${this.hostName}/api/v00/dynamicHP/getPdtListsById?id=${id}`, requestOptions);
                const result = yield response.text();
                const data = yield JSON.parse(result);
                return data;
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    getRecommendationsbyProductId(id, limit) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const requestOptions = {
                    method: 'GET',
                    redirect: 'manual'
                };
                const response = yield fetch(`/recommendations/products.json?product_id=${id}&limit=${limit}`, requestOptions);
                const result = yield response.text();
                const data = yield JSON.parse(result);
                return data;
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    changeCartItem(id, quantity) {
        return __awaiter(this, void 0, void 0, function* () {
            // line is an index starting with 1
            const body = {
                'id': id,
                'quantity': quantity
            };
            const bodyString = JSON.stringify(body);
            try {
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                    },
                    redirect: 'manual',
                    body: bodyString
                };
                const response = yield fetch(`/cart/change.js`, requestOptions);
                const result = yield response.text();
                const data = yield JSON.parse(result);
                return data;
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    getCartItems() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        "Content-Type": "application/json",
                    },
                    redirect: 'manual',
                };
                const response = yield fetch(`/cart.js`, requestOptions);
                const result = yield response.text();
                const data = yield JSON.parse(result);
                return data;
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    addCartItem(items) {
        return __awaiter(this, void 0, void 0, function* () {
            const bodyItems = items.map((el) => {
                return { id: el.variantId, quantity: el.quantity };
            });
            const body = {
                items: bodyItems
            };
            const bodyString = JSON.stringify(body);
            try {
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                    },
                    redirect: 'manual',
                    body: bodyString
                };
                const response = yield fetch(`/cart/add.js`, requestOptions);
                const result = yield response.text();
                const data = yield JSON.parse(result);
                return data;
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    renderSection(sectionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const sections = sectionId.join(',');
            const urlQuery = `/?sections=${sections}`;
            try {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        "Content-Type": "application/json",
                    },
                    redirect: 'manual',
                };
                const response = yield fetch(urlQuery, requestOptions);
                const result = yield response.text();
                const data = yield JSON.parse(result);
                return data;
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    getProductDataByHandle(handle) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const requestOptions = {
                    method: 'GET',
                    redirect: 'manual'
                };
                const response = yield fetch(`/products/${handle}.json`, requestOptions);
                const result = yield response.text();
                const data = yield JSON.parse(result);
                return data;
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    reconMoobiPoints(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const requestOptions = {
                    method: 'GET',
                    redirect: 'manual'
                };
                const res = yield fetch(`${this.hostName}/api/moobiPoints/reconPointsById?customerId=${userId}`, requestOptions);
                const text = yield res.text();
                const data = yield JSON.parse(text);
                return data;
            }
            catch (err) {
                console.log(err);
            }
        });
    }
    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }
    fetchAndParseDOM(url) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetch(url);
                if (!response.ok) {
                    throw new Error(`Network response was not ok: ${response.statusText}`);
                }
                const htmlText = yield response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlText, 'text/html');
                return doc;
            }
            catch (error) {
                console.error('Error fetching and parsing DOM:', error);
                throw error;
            }
        });
    }
}
const moobiQueries = new MoobiQueries('https://moobiwashrepairnavi.df.r.appspot.com');
// const moobiQueries = new MoobiQueries('http://127.0.0.1:3000')
// const moobiQueries = new MoobiQueries('https://20231022t203706-dot-moobiwashrepairnavi.df.r.appspot.com')
